import { PayloadAction } from '../../store.model';
import { PerformancePillar } from '../models/performance-pillar.model';
import { ActionType } from '../my-performance-card.action';
import { PerformanceCardState } from '../my-performance-card.state';

import { TogglePillarCollapseAction } from './toggle.action';
function togglePillarOrMetric(
    totalPillar: PerformancePillar,
    pillarsData: PerformancePillar[],
    pillarId: string,
    metricId?: number,
): {
    updatedTotalPillar: PerformancePillar;
    updatedPillarsData: PerformancePillar[];
} {
    if (totalPillar == null || pillarsData == null) {
        return {
            updatedTotalPillar: totalPillar,
            updatedPillarsData: pillarsData,
        };
    }
    if (pillarId === totalPillar.id) {
        const isCollapsed = !totalPillar.isCollapsed;
        const updatedTotal = { ...totalPillar, isCollapsed };
        const updatedPillars = pillarsData.map((p) => ({ ...p, isCollapsed }));
        return {
            updatedTotalPillar: updatedTotal,
            updatedPillarsData: updatedPillars,
        };
    }
    const updatedPillarsData = pillarsData.map((pillar) => {
        if (pillar.id === pillarId) {
            if (metricId != null) {
                const updatedChildPillars = pillar.childPillars.map((child) =>
                    child.metricId === metricId
                        ? { ...child, isExpanded: !(child.isExpanded ?? false) }
                        : child,
                );
                return { ...pillar, childPillars: updatedChildPillars };
            }
            return { ...pillar, isCollapsed: !pillar.isCollapsed };
        }
        return pillar;
    });
    const allPillarsCollapsed = updatedPillarsData.every((p) => !p.isCollapsed);
    const allPillarsExpanded = updatedPillarsData.every((p) => p.isCollapsed);
    const isExpanded = totalPillar.isCollapsed;
    const newTotalCollapsed =
        allPillarsExpanded ||
        (isExpanded && allPillarsCollapsed ? false : isExpanded);
    const updatedTotalPillar = {
        ...totalPillar,
        isCollapsed: newTotalCollapsed,
    };
    return {
        updatedTotalPillar,
        updatedPillarsData,
    };
}

export const handleTogglePillarResult = (
    state: PerformanceCardState,
    action: PayloadAction<
        ActionType.MY_PERFORMANCE_CARD_TOGGLE_PILLAR_COLLAPSE,
        TogglePillarCollapseAction
    >,
): PerformanceCardState => {
    const { id, metricId, userId } = action.payload;

    const userPerfData = state.userData[userId];
    if (userPerfData == null) {
        return state;
    }
    const { updatedTotalPillar, updatedPillarsData } = togglePillarOrMetric(
        userPerfData.totalPerformancePillar ?? null,
        userPerfData.pillarsData ?? null,
        id,
        metricId,
    );
    return {
        ...state,
        userData: {
            ...state.userData,
            [userId]: {
                ...userPerfData,
                totalPerformancePillar: updatedTotalPillar,
                pillarsData: updatedPillarsData,
            },
        },
    };
};
